import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { I18nextProvider, initReactI18next } from 'react-i18next';

import translationsEnJson from '../../../../public/locale/transperfect/en/translation.json';
import translationsEsJson from '../../../../public/locale/transperfect/es/translation.json';
import translationHtJson from '../../../../public/locale/transperfect/ht/translation.json';
import translationIcJson from '../../../../public/locale/transperfect/ic/translation.json';
import translationKoJson from '../../../../public/locale/transperfect/ko/translation.json';
import translationMyJson from '../../../../public/locale/transperfect/my/translation.json';
import translationViJson from '../../../../public/locale/transperfect/vi/translation.json';
import translationZhJson from '../../../../public/locale/transperfect/zh/translation.json';

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn

  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  // Handle case where initReactI18next might be undefined during test setup
  .use(initReactI18next || { type: '3rdParty', init: () => {} })
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    lng: 'en',
    resources: {
      en: { translation: translationsEnJson },
      es: { translation: translationsEsJson },
      my: { translation: translationMyJson },
      ht: { translation: translationHtJson },
      zh: { translation: translationZhJson },
      vi: { translation: translationViJson },
      il: { translation: translationIcJson },
      ko: { translation: translationKoJson },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export { i18n, I18nextProvider };
